import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import { getActiveCustomer } from 'store/auth';
import {
  changeLanguageRequest,
  isChangingLanguage,
  getCurrentLanguage
} from 'store/language';

import { Content } from 'components/Common';
import { Header, AccountInformation, AccountLanguage } from 'components';

export class Account extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    customer: PropTypes.object.isRequired,
    language: PropTypes.string.isRequired,
    isChangingLanguage: PropTypes.bool.isRequired,
    onChangeLanguage: PropTypes.func.isRequired
  };

  render() {
    return (
      <div>
        <Header
          title={this.props.t('account.title')}
          description={this.props.t('account.description')}
        />

        <Content>
          <div className="row">
            <div className="column small-12 large-8">
              <AccountInformation customer={this.props.customer} />

              <AccountLanguage
                language={this.props.language}
                isSubmitting={this.props.isChangingLanguage}
                onSubmit={this.props.onChangeLanguage}
              />
            </div>
          </div>
        </Content>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  customer: getActiveCustomer(state),
  isChangingLanguage: isChangingLanguage(state),
  language: getCurrentLanguage(state)
});

const mapDispatchToProps = {
  onChangeLanguage: changeLanguageRequest
};

export default translate()(
  connect(mapStateToProps, mapDispatchToProps)(Account)
);



// WEBPACK FOOTER //
// ./src/containers/Account/Account.js